/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetQuestionAndAnswerDtoAnswer
 */
export interface GetQuestionAndAnswerDtoAnswer {
    /**
     * 
     * @type {string}
     * @memberof GetQuestionAndAnswerDtoAnswer
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetQuestionAndAnswerDtoAnswer
     */
    booleanValue?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetQuestionAndAnswerDtoAnswer
     */
    textValue?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetQuestionAndAnswerDtoAnswer
     */
    ts: Date;
}

/**
 * Check if a given object implements the GetQuestionAndAnswerDtoAnswer interface.
 */
export function instanceOfGetQuestionAndAnswerDtoAnswer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "ts" in value;

    return isInstance;
}

export function GetQuestionAndAnswerDtoAnswerFromJSON(json: any): GetQuestionAndAnswerDtoAnswer {
    return GetQuestionAndAnswerDtoAnswerFromJSONTyped(json, false);
}

export function GetQuestionAndAnswerDtoAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuestionAndAnswerDtoAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'booleanValue': !exists(json, 'booleanValue') ? undefined : json['booleanValue'],
        'textValue': !exists(json, 'textValue') ? undefined : json['textValue'],
        'ts': (new Date(json['ts'])),
    };
}

export function GetQuestionAndAnswerDtoAnswerToJSON(value?: GetQuestionAndAnswerDtoAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'booleanValue': value.booleanValue,
        'textValue': value.textValue,
        'ts': (value.ts.toISOString()),
    };
}

